import { render, staticRenderFns } from "./VTabler.vue?vue&type=template&id=688283e2&"
import script from "./VTabler.vue?vue&type=script&lang=js&"
export * from "./VTabler.vue?vue&type=script&lang=js&"
import style0 from "./VTabler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports